import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from './Container';
export function Nav() {
  return <nav className="sticky top-0 z-50 bg-brand-white border-b border-brand-gray300" data-id="element-85" data-mp="120z5jejyy6eh">
      <Container className="flex items-center justify-between py-[18px]" data-id="element-86" data-mp="16yr8d3m5jcxg">
        <Link to="/" className="font-black text-[20px] tracking-[-0.01em]" data-id="element-87" data-mp="1b0m5rx0yp65y">
          THE ABIE AGENCY
        </Link>
        <ul className="hidden md:flex gap-[32px] list-none max-[720px]:hidden" data-id="element-88" data-mp="1g079sluzo4pj">
          <li data-id="element-89" data-mp="1kys6ibb18698">
            <Link to="/#work" className="text-[14px] font-medium hover:text-brand-gray600 transition-colors" data-id="element-90" data-mp="1ky8okuldthv7">
              Work
            </Link>
          </li>
          <li data-id="element-91" data-mp="1uov0adpz9o8m">
            <Link to="/#services" className="text-[14px] font-medium hover:text-brand-gray600 transition-colors" data-id="element-92" data-mp="1unjxag4cwkik">
              Services
            </Link>
          </li>
          <li data-id="element-93" data-mp="23q1hkp0gb32x">
            <Link to="/about" className="text-[14px] font-medium hover:text-brand-gray600 transition-colors" data-id="element-94" data-mp="23pjeb8fdfoli">
              About
            </Link>
          </li>
          <li data-id="element-95" data-mp="1u6g2srlrhbtd">
            <Link to="/#careers" className="text-[14px] font-medium hover:text-brand-gray600 transition-colors" data-id="element-96" data-mp="1u6pqu9n8x8wf">
              Careers
            </Link>
          </li>
          <li data-id="element-97" data-mp="2htxvqqgrifxx">
            <Link to="/contact" className="text-[14px] font-medium hover:text-brand-gray600 transition-colors" data-id="element-98" data-mp="2hufpngfyci2o">
              Contact
            </Link>
          </li>
        </ul>
      </Container>
    </nav>;
}